import { modalReturnHistoryStore } from '@/store'
import { ModalReturnHistoryStoreInterface } from '@/store/ModalReturnHistoryStore'

export class ModalReturnHistoryService {
  public open(params: ModalReturnHistoryStoreInterface) {
    modalReturnHistoryStore.open(params)
  }

  public close() {
    modalReturnHistoryStore.close()
  }
}
